import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
} from "reactstrap";

import Breadcrumbs from "../../../components/common/Breadcrumb";

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { AxiosError, AxiosResponse } from "axios";
import { ApiCore } from "../../../helpers/api_helper";
import { Endpoints } from "../../../utils/Endpoints";
import { amountToCurrency, dateToDbFormat, formattedDate } from "../../../utils/Helpers";
import { Link, useHistory, useLocation } from "react-router-dom";
import { invoiceEndDate, invoiceStartDate } from "../../../utils/Helpers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Formik } from "formik";
import { XSelect } from "../../../components/common/inputs/XSelect";
import { XSearchableSelect } from "../../../components/common/inputs/XSearchableSelect";
import { XTextBox } from "../../../components/common/inputs/XTextBox";
import { ISelectOption } from "../../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../../components/common/inputs/XDatePickerField";
import { XCheckbox } from "../../../components/common/inputs/XCheckbox";
import accounts from "../../../components/accounts";

const ViewFees = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [forms, setForms] = useState<any>([]);
  const [banks, setBanks] = useState<any>([]);
  const [students, setStudents] = useState<any>([]);
  const [records, setRecords] = useState<any>([]);

  const history = useHistory();
  let initialValues: any = {};

  const terms: ISelectOption[] = [
    { value: "I", text: "I" },
    { value: "II", text: "II" },
    { value: "III", text: "III" },
  ];

  const loadSchoolFeesList = (values: any) => {
    if (values.pdf && values.pdf == 1) {
      fetchFile(values)
    } else {
      fetchHtml(values)
    }
  };

  const fetchFile = (values: any) => {
    toast
      .promise(request
        .get(Endpoints.viewFees, { params: { form: values.form, student_id: values.student_id, term: values.term, year: values.year, date: values.date, referenceno: values.referenceno, bank_id: values.bank_id, pdf: 1 } }, "arraybuffer"), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], { type: type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `SchoolFees-${+ new Date()}.pdf`
        link.click()
      });
  }

  const fetchHtml = (values: any) => {
    toast
      .promise(request
        .get(Endpoints.viewFees, { params: { form: values.form, student_id: values.student_id, term: values.term, year: values.year, date: values.date, referenceno: values.referenceno, bank_id: values.bank_id, } }), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        const { records } = response.data;
        setRecords(records);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  }


  const request = new ApiCore();

  const handleSubmit = (values: any) => {
    console.log(values);
    loadSchoolFeesList(values);
  };

  useEffect(() => {
    loadSchoolFeesList({});
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.getSchoolFeesDefaults, {})
      .then((response: AxiosResponse) => {
        const { forms } = response.data;
        let options: any = [];
        options = forms.map((data: any) => ({
          value: data,
          label: data,
          data: JSON.stringify(data),
        }));
        setForms(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.getSchoolFeesDefaults, {})
      .then((response: AxiosResponse) => {
        const { banks } = response.data;
        let options: any = [];
        options = banks.map((data: any) => ({
          value: data.id,
          label: data.name + " - " + data.account,
          data: JSON.stringify(data),
        }));
        setBanks(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);


  useEffect(() => {
    request
      .get(Endpoints.getStudentsList, {})
      .then((response: AxiosResponse) => {
        const { students } = response.data;
        let options: any = [];
        options = students.map((data: any) => ({
          value: data.id,
          label: data.lastname + " " + data.firstname + " - " + data.studentid + " - " + data.form + " " + data.stream,
          data: JSON.stringify(data),
        }));
        setStudents(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const computeTotals = (item: any) => {
    let totalAmount = 0;

    for (let i = 0; i < item.length; i++) {
      totalAmount += item[i].amount;
    }
    return amountToCurrency(totalAmount);
  }

  const computeAmounts = (item: any): number => {
    let totalAmount = 0;

    for (let i = 0; i < item.length; i++) {
      totalAmount += item[i].amount;
    }
    return totalAmount; 
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <MetaTags>
          <title>Record Fees | Treda - React Admin & Dashboard Template</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="View" breadcrumbItem="School Fees" />
          <Row>
            <Col lg="12">
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">School Fees</CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  {!loading && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                          <>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                  <XSearchableSelect
                                    key="form"
                                    id="form"
                                    name={"form"}
                                    options={forms}
                                    label={"Class"}
                                    onChange={(value: any) => {
                                      setFieldValue("form", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="student_id"
                                    id="student_id"
                                    name={"student_id"}
                                    options={students}
                                    label={"Student"}
                                    onChange={(value: any) => {
                                      setFieldValue("student_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="term"
                                    id="term"
                                    name={"term"}
                                    options={terms}
                                    label={"Term"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    id="year"
                                    type={"text"}
                                    name={"year"}
                                    label={"Year"}
                                    placeholder="2014"
                                    onChange={(value: any) => {
                                      setFieldValue("year", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XDatePickerField
                                    key="date"
                                    id="date"
                                    name={"date"}
                                    label={"Date"}
                                    touched={touched}
                                    onChange={setFieldValue}
                                    value={values.date}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    id="referenceno"
                                    type={"text"}
                                    name={"referenceno"}
                                    label={"Ref #"}
                                    onChange={(value: any) => {
                                      setFieldValue("referenceno", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="bank_id"
                                    id="bank_id"
                                    name={"bank_id"}
                                    options={banks}
                                    label={"Bank"}
                                    onChange={(value: any) => {
                                      setFieldValue("bank_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <div>&nbsp;</div>
                                  <XCheckbox
                                    key="pdf"
                                    id=""
                                    name={"pdf"}
                                    label={"PDF"}
                                    value="1"
                                    includeTopPadding={false}
                                    onChange={setFieldValue}
                                    size={{}} />
                                </Col>
                                <Col lg={2}>
                                  <div>&nbsp;</div>
                                  <Button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Search
                                  </Button>
                                </Col>
                              </Row>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th><b>Reference#</b></th>
                                    <th className="text-center"><b>Date</b></th>
                                    <th className="text-center"><b>Term</b></th>
                                    <th className="text-center"><b>Year</b></th>
                                    <th className="text-center"><b>Name</b></th>
                                    <th className="text-center"><b>Class</b></th>
                                    <th className="text-center"><b>Amount</b></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {records && records.map((item: any) => {
                                    return (<><tr key={item.id}>
                                      <td>{item.referenceno}</td>
                                      <td className="text-center">{formattedDate(item.date)}</td>
                                      <td className="text-center">{item.term}</td>
                                      <td className="text-center">{item.year}</td>
                                      <td className="text-center">{item.student ? item.student.lastname + " " + item.student.firstname + " - " + item.student.studentid + " - " + item.student.form + " " + item.student.stream : ""}</td>
                                      <td className="text-center">{item.form}</td>
                                      <td className="text-center">{amountToCurrency(item.amount)}</td>
                                    </tr>
                                    </>)
                                  })}
                                  <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{"TOTAL"}</b></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-center"><b>{amountToCurrency(computeAmounts(records))}</b></td>
                                  </tr>
                                </tbody>
                              </table>
                            </Form>
                            <hr />
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewFees;
